/**
 * NLB-GW
 *
 * Contact: service@rheinenergie.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PrivateAddressData { 
    /**
     * Zip Code / PLZ
     */
    postCode?: string;
    cityName?: string;
    streetName?: string;
    houseNum?: string;
    /**
     * id reflecting title attribute like \'Herr\', \'Frau\', \'keine Anrede\', \'Firma\' etc.
     */
    titleId?: string;
    /**
     * firstname of person
     */
    firstname?: string;
    /**
     * lastname of person
     */
    surname?: string;
    /**
     * Email address
     */
    email?: string;
}

